import {Link} from 'react-router-dom';

function ValuesDetail() {
  return (
    <div className="ltn__page-details-area ltn__service-details-area mb-105">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="ltn__page-details-inner ltn__service-details-inner">
              <p className="values_p">
                {' '}
                <span className="ltn__first-letter">W</span>e are inspired by
                the Christian Gold rule and duty to others in the Gospel of
                Mathew (7:12): ‘’In everything, do to others what you would have
                them do to you....’’. Quality health and homecare services are
                also guided by ‘the 6 Cs’, a set of values upheld by the NHS for
                all health and social care staff.
              </p>
              <p className="values_p2 mt-15">
                Thus, we always strive to provide a quality, reflective,
                responsive, safe, and person-centred service.
              </p>
            </div>
          </div>
          <div className="col-lg-4">
            <aside className="sidebar-area ltn__right-sidebar">
              <h2 className="text-center compassion">Also see:</h2>
              <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                <ul>
                  <li className="">
                    <Link to="/how-we-deliver">
                      How we deliver our care
                      <span>
                        <i className="fas fa-arrow-right"></i>
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/funding">
                      Funding your care
                      <span>
                        <i className="fas fa-arrow-right"></i>
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/our-care">
                      Our care
                      <span>
                        <i className="fas fa-arrow-right"></i>
                      </span>
                    </Link>
                  </li>
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ValuesDetail;
